<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Loja</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <reseller-page />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import ResellerPage from '_modules/reseller/components/ResellerPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ResellerModel';

export default {
  name: 'reseller-create',
  components: {
    ResellerPage,
  },
  methods: {
    ...mapActions(['clearReseller']),
  },
  created() {
    Events.$emit(_LOAD_MODEL_, MODEL);
    this.clearReseller();
    Events.$emit('sidebarVisible', false);
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
    Events.$off('sidebarVisible');
  },
};
</script>
